import { DetailUsers } from '../models/detailUsers';
import { UserPanelModule } from './../components/user-panel/user-panel.component';
import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, take } from 'rxjs/operators';
import { User} from '../models/users';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  usersCollection: AngularFirestoreCollection<User>;
  userDoc: AngularFirestoreDocument<User>;
  users: Observable<User[]>;
  user: Observable<User>;



  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private afs: AngularFirestore,
    private httpClient: HttpClient
  ) {
    this.usersCollection = this.afs.collection('users');
  }

  getUsers(): Observable<User[]> {
    this.users = this.usersCollection.valueChanges();
    return this.users;
  }

  getUser(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'getUser/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  
  getBeneficiaries(data): Observable<DetailUsers> {
    return this.httpClient.post<any>(environment.urlApi + 'getBeneficiaries/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  newUser(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'userAdd/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  newUserWithoutApp(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'userAddWithoutApp/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  updateUser(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'updateUser/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  deleteUserApi(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'deleteUser/', JSON.stringify({'id': data}), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  userAddAuth(data): Observable<User> {
    return this.httpClient.post<any>(environment.urlApi + 'userAddAuth/', JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  uploadUsersCsv(data): Observable<any> {
    return this.httpClient.post<any>(environment.urlApi + 'uploadUsersCsv/', data)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  // User -> Program -> Card
  updateCard(_userId,_programId, _card): Observable<any> {
    return this.httpClient.put(environment.urlApi + 'program/card', {
      userId: _userId,
      programId: _programId,
      card: _card
    });
  }

  uploadUsersCsvWithoutApp(data): Observable<any> {
    return this.httpClient.post<any>(environment.urlApi + 'uploadUsersCsvWithoutApp/', data)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  updateEmail(_uid, _email) {
    return this.httpClient.post<any>(environment.urlApi + 'users/email/update', {
      uid: _uid,
      email: _email
    });
  }
  sendEmailBienvenida(_email: any[]) {
    return this.httpClient.post<any>(environment.urlApi + 'users/sendEmailBienvenida', {
      usersEmail: _email
    });
  }

  async deleteUser(
    docId: string,
    newData: any
  ): Promise<{ company: User } | any> {
    try {
      let response = await this.afs.collection('users').doc(`${docId}`).delete();
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  getUserAsPromise(id: string): Promise<User | null> {
    return new Promise((resolve, reject) => {
      this.afs
        .doc<User>(`users/${id}`)
        .valueChanges()
        .pipe(take(1))
        .subscribe(
          (user) => {
            resolve(user);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }


  // Error handling
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  getCompanyCardUsers(companyId: number): Observable<User[]> {
    const adminUsers = this.afs.collection<User>('users', (ref) =>
      ref
        .where('belongsToProgram', '==', true)
        .where('companyId', '==', companyId)
        .where('level','==',5)
    );
    return adminUsers.valueChanges();
  }

  getCompanyAdminUsers(companyId: string): Observable<User[]> {
    const adminUsers = this.afs.collection<User>('users', (ref) =>
      ref
        .where('belongsToIhunterProgram', '==', false)
        .where('belongsToProgram', '==', false)
        .where('companyId', '==', companyId)
        .where('level','in',[4,5,6])
    );
    return adminUsers.valueChanges();
  }

  getAllUsers(): Observable<User[]> {
    const adminUsers = this.afs.collection<User>('users', (ref) =>
      ref
        .where('belongsToIhunterProgram', '==', false)
        .where('belongsToProgram', '==', false)
        .where('level','in',[1,2,3,4,5,6,7])
    );
    return adminUsers.valueChanges();
  }

  getBrokerUsers(companiesIds: any[]): Observable<User[]> {
    const adminUsers = this.afs.collection<User>('users', (ref) =>
      ref
        .where('belongsToIhunterProgram', '==', false)
        .where('belongsToProgram', '==', false)
        .where('companyId', 'in', companiesIds)
        .where('level','>=',4)
    );
    return adminUsers.valueChanges();
  }
  getListUsers(userssIds: any[]): Observable<User[]> {
    const adminUsers = this.afs.collection<User>('users', (ref) =>
      ref
        .where('belongsToIhunterProgram', '==', false)
        .where('belongsToProgram', '==', false)
        .where('id', 'in', userssIds)
    );
    return adminUsers.valueChanges();
  }
  isLevel(_User: any, _Levels: number[]) {
    return _Levels.includes(_User.level);
  }
}
